import React, { Component } from "react";
import {
  ActivityPackCardContainer,
  ActivityPackContainer,
  ActivityPackTitle,
  ActivitySubHeading,
} from "./ActivityPackCard.styled";
import {
  CardIcon,
  CardIconContainer,
  Chips,
  CountOverlayContainer,
  CountItem,
} from "@sc/custom.styled";
import Permission from "@s/permission";
import {
  SyncActivityContainer,
  SyncStoryIcon,
} from "../../activities-list/ActivityCard/ActivityCard.styled";
import { connectStore } from "redux-box";
import { module as activity } from "@st/activity";

class ActivityPackCard extends Component {
  handleSyncActivityPack = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let { activityPack } = this.props;

    let syncList = this.props.activity.sync_activitypacks_list;

    if (syncList.map((act) => act.id).includes(activityPack.id)) {
      let newList = syncList.filter((act) => act.id !== activityPack.id);
      console.log(newList);
      this.props.activity.setSyncActivityPacks(newList);
    } else {
      this.props.activity.setSyncActivityPacks([...syncList, activityPack]);
    }
  };

  render() {
    let activityPack = this.props.activityPack;
    let permission = this.props.permission;

    const isChecked = this.props.activity.sync_activitypacks_list.some(
      (act) => act.id === activityPack.id
    );

    return (
      <ActivityPackCardContainer image={activityPack.image}>
        <ActivityPackContainer>
          <CardIconContainer>
            <Chips>{activityPack.activity_count} Activities</Chips>
            {Permission.getPermission(permission, "change_activity") ? (
              <CardIcon
                primary
                onClick={this.props.handlePublishClick}
                bg={activityPack.is_published}
              >
                <i className="fa fa-check" />
              </CardIcon>
            ) : null}
            {Permission.getPermission(permission, "delete_activity") ? (
              <CardIcon onClick={this.props.handleDeleteClick}>
                <i className="fa fa-trash" />
              </CardIcon>
            ) : null}
          </CardIconContainer>
          <ActivityPackTitle>{activityPack.name}</ActivityPackTitle>
          <ActivitySubHeading>{activityPack.description}</ActivitySubHeading>
        </ActivityPackContainer>
        <CountOverlayContainer style={{ width: "45px", height: "30px" }}>
          <CountItem>
            <i className="fa fa-shopping-cart" />
            <span>{activityPack.purchase_count}</span>
          </CountItem>
        </CountOverlayContainer>
        <SyncActivityContainer
          color={"white"}
          bottom = {'5px'}
          onClick={(e) => this.handleSyncActivityPack(e)}
        >
          <SyncStoryIcon primary color={isChecked ? "#432666" : "white"}>
            {isChecked ? <i className="fa fa-check" /> : null}
          </SyncStoryIcon>
          Sync Activity Pack
        </SyncActivityContainer>
      </ActivityPackCardContainer>
    );
  }
}

export default connectStore({
  activity,
})(ActivityPackCard);